import { IBillBoxData, IBillingData, IBillingState, IRebillingData } from "../interfaces/ibilling-status";

export const BILLING_STATE: IBillingState = {
    billbox: <IBillBoxData>{},
    billingData: <IBillingData>{},
    rebilling: <IRebillingData>{},
    billingMessages: {}
};
